import React from "react";
import { StatementContext } from "../../contexts/statementContext";

// import { Container } from './styles';

function useStatementContext() {
  const values = React.useContext(StatementContext);
  return values;
}

export default useStatementContext;
